module.exports = __webpack_public_path__ + "img/group1.a4e09ec5.png";